module.exports = __webpack_public_path__ + "img/5-1.56d687d6.jpg";